import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import { articles } from "@/blogData";

export default function BlogPreview() {
  const { lang, t } = useLang();

  return (
    <section id="blog" data-testid="blog-section" className="bg-[#FAF8F5] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#C87A57]">{t.blog.overline}</p>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight tracking-tight text-[#0E1B2A]">
              {t.blog.title}
            </h2>
            <p className="mt-4 text-base sm:text-lg text-[#475569]">{t.blog.sub}</p>
          </div>
          <Link
            data-testid="blog-all-link"
            to="/blog"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#2C5E7A] transition-colors hover:text-[#C87A57]"
          >
            {t.blog.more}
            <ArrowUpRight size={16} />
          </Link>
        </Reveal>

        <div className="mt-14 grid gap-7 md:grid-cols-3">
          {articles.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.1}>
              <Link
                data-testid={`blog-card-${a.slug}`}
                to={`/blog/${a.slug}`}
                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-[#0E1B2A]/8 bg-white shadow-[0_10px_30px_rgba(14,27,42,0.04)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_25px_50px_-15px_rgba(14,27,42,0.18)]"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={a.image}
                    onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = a.fallback; }}
                    alt={a[lang].title}
                    className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110"
                  />
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <p className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#94A3B8]">
                    <Clock size={12} />
                    {a.readTime} {t.blog.min}
                  </p>
                  <h3 className="mt-3 font-serif text-xl font-semibold leading-snug text-[#0E1B2A] transition-colors group-hover:text-[#C87A57]">
                    {a[lang].title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-[#475569]">{a[lang].excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#2C5E7A]">
                    {t.blog.read}
                    <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
